import { useState } from 'react';
import { PageHeading } from '@portal_components/components/PageHeading';
import { useDefinedParams } from '../hooks/useDefinedParams';
import { EHttpMethod, usePortalQuery } from '../hooks/usePortalQuery';
import { Appointment, BaseExceptionDetails, EExceptionType, HandoverExceptions } from '../types';
import { HandoverExceptionsListItem } from '../elements/Exceptions/HandoverExceptionsListItem';

type HandoverExceptionDetails = BaseExceptionDetails & {
  errorDescription?: string;
  detailsInOds?: boolean;
};

export const HandoverExceptionsPage = () => {
  const [handoverFileName] = useDefinedParams(['handoverFileName']);
  const [expandedRecordIndex, setExpandedRecordIndex] = useState<number | null>(null);

  const { data: handoverExceptions, isLoading: exceptionsLoading } = usePortalQuery<HandoverExceptions<HandoverExceptionDetails>>(
    EHttpMethod.GET,
    `exceptions?exceptionType=${EExceptionType.VALIDATION_EXCEPTION}&handoverFileName=${encodeURIComponent(handoverFileName)}`,
    `get-exceptions-${handoverFileName}`,
    true
  );

  const { data: appointments, isLoading: appointmentsLoading } = usePortalQuery<{
    [mprn: string]: Appointment;
  }>(
    EHttpMethod.POST,
    `get-appointment/bulk`,
    `get-appointment-exceptions-bulk`,
    !exceptionsLoading && !!handoverExceptions,
    handoverExceptions
      ? {
          contractId: handoverExceptions.contractId,
          mpans: handoverExceptions.exceptions.map(site => site.siteDetails.mprn)
        }
      : undefined
  );

  return (
    <div>
      <PageHeading
        title={`Exceptions for ${handoverFileName}`}
        navigationButtons={[
          {
            title: 'Back',
            path: '/exceptions',
            icon: '/back.svg',
            className: 'w-6 h-6'
          }
        ]}
      />
      {exceptionsLoading && <div>Loading exceptions...</div>}
      {appointmentsLoading && <div>Loading appointments...</div>}
      {!exceptionsLoading && handoverExceptions?.exceptions.length === 0 && <p>No exceptions found for {handoverFileName}</p>}
      {!exceptionsLoading &&
        !!handoverExceptions &&
        !appointmentsLoading &&
        !!appointments &&
        handoverExceptions.exceptions.map(({ siteDetails, errorDescription, detailsInOds }, index) => (
          <HandoverExceptionsListItem
            key={siteDetails.mprn}
            siteDetails={siteDetails}
            index={index}
            expandedRecordIndex={expandedRecordIndex}
            setExpandedRecordIndex={setExpandedRecordIndex}
            appointmentActive={!!siteDetails.mprn && !!appointments?.[siteDetails.mprn]?.active}
            appointmentDuplicate={!!siteDetails.mprn && !!appointments?.[siteDetails.mprn]?.duplicate}
            errorDescription={errorDescription}
            detailsInOds={detailsInOds}
            contractId={handoverExceptions.contractId}
            customerGroupId={handoverExceptions.customerGroupId}
            handoverFileName={handoverFileName}
          />
        ))}
    </div>
  );
};
